import React from 'react'
import { Text } from 'theme-ui'
import TextList from '@components/TextList'
import { FaRegClock } from 'react-icons/fa'
import rv from '@components/utils/buildResponsiveVariant'
import { getSelectedArticleTitle } from '../../../../themes/gatsby-theme-flexiblog-personal/src/helpers/nr-postDate.helper'

const CardFooterInfo = ({
  variant,
  date,
  eventdate,
  timeToRead,
  title,
  callFrom,
  updatedAt,
  readingTime
}) => {
  const authors = getSelectedArticleTitle(title)
  let updatedAtAuthor = new Date(authors[0].updatedAt).toLocaleDateString(
    'en-us',
    {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
  )

  return (
    <TextList nowrap>
      {
        <Text sx={{ variant: rv(variant, 'date') }}>
          {eventdate ? eventdate : callFrom === 'Blog' ||callFrom === 'Video' ?   date:updatedAtAuthor}
        </Text>
      }
      {timeToRead && (
        <Text sx={{ variant: rv(variant, 'timeToRead') }}>
          <FaRegClock css={{ verticalAlign: `middle` }} />{' '}
          {readingTime && readingTime.minutes
            ? readingTime.minutes
            : timeToRead}{' '}
          min
        </Text>
      )}
    </TextList>
  )
}

export default CardFooterInfo
